// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import setLanguage from "next-translate/setLanguage";
import { useTheme } from "@mui/material/styles";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";

import { Form, Grid } from "@/components/core";
import { NavbarSelect } from "../navbar/navbar-select";

export function LanguageSelect() {
  const { lang } = useTranslation();
  const theme = useTheme();

  return (
    <Form>
      <NavbarSelect
        hideBorder
        color="inherit"
        value={lang}
        sx={{
          color: theme.palette.text.contrast,
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "inherit",
          },
        }}
        options={[
          { value: "tr", label: "TR" },
          { value: "en", label: "EN" },
        ]}
        onChange={({ target }) => {
          setLanguage(target.value);
        }}
        renderItem={(item) => (
          <Grid spacing={2}>
            <Grid.Item>
              <Image
                style={{ padding: 0, margin: 0 }}
                width={30}
                alt=""
                loading="lazy"
                src={`/images/flags/${item.value}-flag.png`}
              />
            </Grid.Item>
            <Grid.Item>{item.label}</Grid.Item>
          </Grid>
        )}
      />
    </Form>
  );
}
